export const listMenu = [
  {
    id: 1,
    name: "Home",
    icon: <span className="lnr lnr-home icon-bottom-bar"></span>,
    path: "/",
  },
  {
    id: 3,
    name: "Esplora",
    icon: <span className="lnr lnr-magnifier icon-bottom-bar"></span>,
    path: "/explore",
  },
  {
    id: 4,
    name: "Calendario",
    icon: <span className="lnr lnr-calendar-full icon-bottom-bar"></span>,
    path: "/calendar",
  },
  {
    id: 5,
    name: "Notifiche",
    icon: <span className="lnr lnr-alarm icon-bottom-bar"></span>,
    path: "/notifications",
  },
  {
    id: 2,
    name: "Gestisci",
    icon: <span className="lnr lnr-magic-wand icon-bottom-bar"></span>,
    path: "/dashboard",
    subPages: [
      {
        id: 1,
        name: "Modifica associazione",
        path: "/dashboard/{{id_association}}/edit-association",
      },
      {
        id: 2,
        name: "Crea evento",
        path: "/dashboard/{{id_association}}/create-event",
      },
      {
        id: 3,
        name: "Calendario associazione",
        path: "/calendar?admin={{id_association}}",
      },
      {
        id: 4,
        name: "Visualizza eventi",
        path: "/dashboard/{{id_association}}/list-events",
      },
      {
        id: 5,
        name: "Richieste volontari",
        path: "/dashboard/{{id_association}}/list-volunteers",
      },
      {
        id: 6,
        name: "Richieste turni",
        path: "/dashboard/{{id_association}}/request-shift",
      },
      {
        id: 7,
        name: "Domande",
        path: "/dashboard/{{id_association}}/list-question",
      },
      {
        id: 8,
        name: "Invia notifica",
        path: "/dashboard/{{id_association}}/send-notification",
      },
      {
        id: 9,
        name: "Notifiche inviate",
        path: "/dashboard/{{id_association}}/notifications-board-association",
      },
    ],
  },
];
